import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, of } from 'rxjs';
import {
  AppNotification,
  NotificationsPageResponse,
} from '../models/notification-api.models';
import { mapNotificationFromApi } from '../utils/notification.utils';
import { ApiConfigService } from './api-config.service';

const PAGE_SIZE = 5;

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiConfig: ApiConfigService,
  ) {}

  fetchPage(userId: string, currentPage: number): Observable<NotificationsPageResponse> {
    const url = this.apiConfig.notificationsPageUrl;
    return this.http
      .post<NotificationsPageResponse>(url, {
        currentpage: currentPage,
        itemsperpage: PAGE_SIZE,
        user: userId,
        deleted: false,
      })
      .pipe(
        map((response) => ({
          ...response,
          data: (response.data ?? []).map((item) =>
            mapNotificationFromApi(item as unknown as Record<string, unknown>),
          ),
        })),
      );
  }

  markAsRead(ids: string[]): Observable<void> {
    if (!ids.length) {
      return of(undefined);
    }

    return this.http.patch<void>(this.apiConfig.notificationsMarkReadUrl, { ids });
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiConfig.notificationsDeleteBaseUrl}${id}`);
  }

  get pageSize(): number {
    return PAGE_SIZE;
  }
}
